import Vue from 'vue';
import Component from 'vue-class-component';
import {ProductSection, Product} from '../../models/ProductModels';
import {Viewport} from '../../models/Viewport';
import ProductLink from './ProductLink.vue';
import ProductLinkSoftbook from './ProductLinkSoftbook';



@Component({
name:"servicepack-section",
props:{
    alservpackentry:{

    },
    viewport:{

    }

},
components:{
    'product-link':ProductLink,
    'product-link-softbook':ProductLinkSoftbook
}
})

export default class ProductServicePackComponent extends Vue{
viewport:Viewport;
alservpackentry:any; 
isSoftbookLink:boolean=false;

get servicePackName():string{ 
    //console.log('Mitten im LEben:', this.alprodentry);
    return "this.alservpack.name";
}

get productcIds(){

   //console.log('ALL- PRODUCTSIDS: ', this.alprodentry[1]);
    
return "this.alprodentry[1]";
}

get packProducts(){
    return "Products of pack";
}


/*
   {
          "id": "product-crte",
          "name": "CRTE",
          "description": "",
          "orderNumber": 7,
          "version": "V11.1",
          "fullVersion": "V11.1;CV",
          "spaceKey": "psCRTEV111de",
          "spaceUrl": "http://bs2manuals.g02.fujitsu.local:8090/psCRTEV111de"
        },

*/


routerLinkForSoftbook(servPackentry:any){
    return `${this.$i18n.locale}/product/${servPackentry.spaceKey}`;
}

routerLinkServicePackForSoftbook(servPackentry:any){
    return `${this.$i18n.locale}/servicePack/${servPackentry.spaceKey}`;
}

created(){
    this.isSoftbookLink = this.viewport.viewportEvironment==='softbook';
   // var test = this.alservpackentry;
    //console.log("SERVICEPACK : TEST:", this.alservpackentry);
}
 
}